// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"CarouselVar_imageContainer__dp5pO","carouselImage":"CarouselVar_carouselImage__5wOyZ","slickCaption":"CarouselVar_slickCaption__vZ9MQ"};